
const quizPrev = (e) => {
	e.previousElementSibling.classList.add('is-active')
}

const quizNext = (e) => {
	e.nextElementSibling.classList.add('is-active')
}

const quizDots = (step, dot) => {
	let i = 0;
	for (i = 0; i < dot.length; i++) {
		if (i<step) {
			dot[i].classList.add('is-active')
		} else {
			dot[i].classList.remove('is-active')
		}
	}
}

const quizAction = (e) => {
	e.preventDefault();

	const quiz = e.target.closest('.quiz')
	const quizBar = quiz.querySelector('.quiz-bar')
	const quizDot = quiz.querySelectorAll('.quiz-dot-item')
	const quizActive = quiz.querySelector('.quiz-box.is-active')
	const btnType = e.target.dataset.type
	let step = parseInt(quizActive.dataset.step)

	quizActive.classList.remove('is-active')

	if (btnType === 'next') {
		quizNext(quizActive)
		step++
	} else {
		quizPrev(quizActive)
		step--
	}

	if (step > 0) {
		quizBar.style.display = 'block'
	} else {
		quizBar.style.display = 'none'
	}

	quizDots(step, quizDot)
}

function stateHandle(e) {
	const checkedWrap = e.target.closest('.quiz-ckeck')
	const check = checkedWrap.querySelectorAll('input:checked')
	const button = checkedWrap.nextElementSibling.querySelector('button')

	if (check.length > 0) {
		button.disabled = false
	} else {
		button.disabled = true
	}
}

function quizContact() {
	const quiz = this.closest('.quiz')
	const btnVal = quiz.querySelector('.btnCnt')
	const value = this.dataset.value

	btnVal.textContent = value
}

function init() {
	const buttons = document.querySelectorAll('.js-quiz-btn')
	const checkbox = document.querySelectorAll('.quiz-ckeck-input')
	const contact = document.querySelectorAll('.quiz-contact-label')

	if(buttons) {
		buttons.forEach((button) => {
			button.addEventListener('click', quizAction)
		})

		checkbox.forEach((item) => {
			item.addEventListener("change", stateHandle);
		})

		contact.forEach((item) => {
			item.addEventListener('click', quizContact);
		})
	}
}

export default {
	init,
};
